const SOBBar = ({ bgColor,transactorSOBBannerHTML  }) => {

    if (transactorSOBBannerHTML === null) {
        return <></>
    }

    return (
        <div className={`container-fluid SOBBar fixed-top ${bgColor}`} style={{ 'zIndex': '1040' }} dangerouslySetInnerHTML={{ __html: transactorSOBBannerHTML }}>

        </div>
    );
}

export default SOBBar;